export default __webpack_public_path__ + "static/media/reflive-b.c431fdd4.svg";